import { render, staticRenderFns } from "./OtomoTableInner.vue?vue&type=template&id=3f70f00a&"
import script from "./OtomoTableInner.vue?vue&type=script&lang=ts&"
export * from "./OtomoTableInner.vue?vue&type=script&lang=ts&"
import style0 from "./OtomoTableInner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
